import React from 'react';
import { Video } from '../../../interfaces';
import { Link } from 'react-router-dom';
import * as Dialog from '@radix-ui/react-dialog';
import { Cross2Icon } from '@radix-ui/react-icons';

const VideoItem: React.FC<{ isListInView1: boolean; item: Video }> = ({ isListInView1, item }) => {
  return (
    <>
      <li key={item.id}>
        <Dialog.Root>
          <Link
            to={`/videos/dir/${item.categoriaDesc.toLowerCase()}`}
            title={item.categoriaDesc.toLowerCase()}
            className="ml-auto mr-4 w-min whitespace-nowrap overflow-hidden max-w-[10rem] text-center text-ellipsis bg-green-200 text-green-600 px-4 py-1 rounded-t-md transition dark:bg-slate-700 dark:text-slate-200 block hover:bg-green-300 dark:hover:bg-green-500"
          >
            {item.categoriaDesc}
          </Link>
          <div
            className={`relative flex rounded-[20px] w-full !p-4 3xl:p-![18px] bg-white transition hover:shadow-lg hover:shadow-slate-300 dark:bg-slate-800 dark:hover:shadow-transparent ${
              isListInView1 ? 'flex-row sm:h-32' : 'flex-col h-auto'
            }`}
          >
            <div className={`h-full w-full ${isListInView1 ? 'flex' : ''}`}>
              <Dialog.Trigger asChild>
                <div className={`relative w-full ${isListInView1 ? 'h-full' : 'h-52'}`}>
                  <div
                    style={{
                      backgroundImage: `url(https://horizon-tailwind-react-git-tailwind-components-horizon-ui.vercel.app/static/media/Nft3.3b3e6a4b3ada7618de6c.png)`,
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: 'cover',
                    }}
                    className={`mb-3 h-full w-full rounded-xl`}
                  />
                </div>
              </Dialog.Trigger>
              <div className="my-3 flex items-center justify-between px-1 md:items-start">
                <div className="mb-2">
                  <p className="text-lg font-bold text-navy-700 truncate"> {item.titulo} </p>
                  <p className="mt-1 text-sm font-medium text-gray-600 md:mt-2">Por Atitudevs </p>
                </div>
              </div>
            </div>
          </div>
          <Dialog.Portal>
            <Dialog.Overlay className="bg-blackA9 data-[state=open]:animate-overlayShow fixed inset-0" />
            <Dialog.Content className="data-[state=open]:animate-contentShow fixed top-[50%] left-[50%] max-h-[85vh] w-[90vw] max-w-[850px] translate-x-[-50%] translate-y-[-50%] rounded-[6px] bg-white p-[25px] shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none">
              <Dialog.Title className="text-mauve12 m-0 text-[17px] font-medium">{item.titulo}</Dialog.Title>
              <div>
                <iframe className="w-full h-96" src={decoreUrl(item.url)} title={item.titulo}></iframe>
              </div>
              <Dialog.Close asChild>
                <button
                  className="text-violet11 hover:bg-violet4 focus:shadow-violet7 absolute top-[10px] right-[10px] inline-flex h-[25px] w-[25px] appearance-none items-center justify-center rounded-full focus:shadow-[0_0_0_2px] focus:outline-none"
                  aria-label="Close"
                >
                  <Cross2Icon />
                </button>
              </Dialog.Close>
            </Dialog.Content>
          </Dialog.Portal>
        </Dialog.Root>
      </li>
    </>
  );
};

export default React.memo(VideoItem);

const decoreUrl = (url: string) => {
  let _url_fix = '';
  if (url.includes('vimeo')) {
    const urlArray = url.split('/')[3];
    _url_fix = `https://player.vimeo.com/video/${urlArray}?title=0&byline=0&portrait=0`;
  } else {
    if (url.split('/')[2] === 'youtu.be') {
      _url_fix = `https://www.youtube.com/embed/${url.split('/')[3]}`;
    } else {
      _url_fix = url.replace('watch?v=', 'embed/');
    }
  }
  return _url_fix;
};
